<template>
  <div class="chatItem">
    <div class="userInfo">
      <img :src="chatItem.avatar || defaultAvatar" alt="用户头像" />
    </div>
    <div class="chatWrap">
      <div class="nickname">{{ chatItem.nickname }}</div>
      <div class="chatMsg">
        <span class="msgTag" :style="{backgroundColor: tagColor}">{{ chatItem.tag || '消息' }}</span>
        {{ chatItem.chatContext }}
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
export default {
  name: "ChatMsgItem",
  props: {
    chatItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultAvatar: defaultAvatar,
      tagColors: {
        '系统': '#07C160',
        '通知': '#FF9900',
        '活动': '#FF2442',
        '默认': '#576B95'
      }
    }
  },
  computed: {
    tagColor() {
      return this.tagColors[this.chatItem.tag] || this.tagColors['默认'];
    }
  }
}
</script>

<style lang="less" scoped>
.chatItem {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  animation: fadeIn 0.5s ease;

  .userInfo {
    margin-left: 25px;
    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 2px solid #576B95;
    }
  }

  .chatWrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 6px;

    .nickname {
      color: #576B95;
      font-size: 12px;
      margin-bottom: 3px;
      background-color: rgba(87, 107, 149, 0.1);
      padding: 3px 6px;
      border-radius: 3px;
      font-weight: bold;
    }

    .chatMsg {
      font-size: 13px;
      font-weight: 500;
      line-height: 17px;
      color: #333;
      overflow-wrap: break-word;
      background: linear-gradient(to right, #f0f4ff, #e6ebff);
      padding: 8px 12px;
      border-radius: 7px;
      max-width: 280px;
      position: relative;
      border: 1px solid #d0d8ff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

      .msgTag {
        display: inline-block;
        color: white;
        font-size: 10px;
        padding: 1px 4px;
        border-radius: 2px;
        margin-right: 6px;
        transform: translateY(-1px);
      }

      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 5px;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-right-color: #f0f4ff;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>